import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=cb4ef65e&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddButton.vue"
export default component.exports